import { OverlayWappPanel, WappPanel } from '$logic/wapp-panels'
import { getOpenedRoomId } from '$logic/opened-room'
import { isVodActivatedInRoom } from '$logic/hall/react-hook'

const BLOG_CREATOR_WAPP_ID = 'blog-blog-creator'
const FORUM_CREATOR_WAPP_ID = 'forum-forum-creator'
const RAHKAR_CREATOR_WAPP_ID = 'rahkar-rahkar-creator'
const NEVISEH_CREATOR_WAPP_ID = 'neviseh-neviseh-creator'
const USAGE_DASHBOARD_WAPP_ID = 'usage-dashboard-usage-dashboard'

const EVENT_CREATOR_WAPP_ID = 'event-event-creator'
const MULTIMEDIA_CREATOR_WAPP_ID = 'multimedia-multimedia-creator'
const MAP_WAPP_ID = 'map-map'
const SUPPORT_WAPP_ID = 'support-support'
const STUDENT_SUPPORT_WAPP_ID = 'support-student-support'

const MULTIPLE_CHOICE_EXAM_CREATOR_WAPP_ID = '6874e7ec793853d4a909438d'
const DESCRIPTIVE_EXAM_CREATOR_WAPP_ID = '687510bfa79b1cf9bdddca0a'
const UNIT_TEST_CREATOR_WAPP_ID = '609d3bb8526d2ee0f383a6e2'
const DARSNAMEH_CREATOR_WAPP_ID = '609c2b38526d2ee0f383a6df'
const HOMEWORK_CREATOR_WAPP_ID = '68755f120f47c0efaee8c68e'
const ROOZNEGAR_CREATOR_WAPP_ID = ''
const ARTICLE_CREATOR_WAPP_ID = '60a772ca526d2ee0f383a6e7'
const POST_CREATOR_WAPP_ID = 'post-post-creator'
const POLL_CREATOR_WAPP_ID = 'poll-poll-creator'
const FORM_CREATOR_WAPP_ID = 'form-form-creator'

const ISSUE_WAPP_ID = 'porsesh-porsesh-main'

export function openIssue(channelId: string) {
  WappPanel.openWapp({ wappId: ISSUE_WAPP_ID, input: { channelId } })
}

export function openPollCreator() {
  WappPanel.openWapp({ wappId: POLL_CREATOR_WAPP_ID })
}

export async function openPostCreator() {
  const openedRoomId = getOpenedRoomId()
  const vodActivated = await isVodActivatedInRoom(openedRoomId)
  WappPanel.openWapp({
    wappId: POST_CREATOR_WAPP_ID,
    input: {
      vodActivated,
    },
  })
}

export function openFormCreator() {
  WappPanel.openWapp({ wappId: FORM_CREATOR_WAPP_ID })
}

export function openMultipleChoiceExamCreator() {
  WappPanel.openWapp({ wappId: MULTIPLE_CHOICE_EXAM_CREATOR_WAPP_ID })
}

export function openDescriptiveExamCreator() {
  WappPanel.openWapp({ wappId: DESCRIPTIVE_EXAM_CREATOR_WAPP_ID })
}

export function openUnitTestCreator() {
  WappPanel.openWapp({ wappId: UNIT_TEST_CREATOR_WAPP_ID })
}

export function openDarsnamehCreator() {
  WappPanel.openWapp({ wappId: DARSNAMEH_CREATOR_WAPP_ID })
}

export function openHomeWorkCreator() {
  WappPanel.openWapp({ wappId: HOMEWORK_CREATOR_WAPP_ID })
}

export function openArticleCreator() {
  WappPanel.openWapp({ wappId: ARTICLE_CREATOR_WAPP_ID })
}

export function openRooznegarCreator() {
  // TODO: Send rooznegar inline wapp into chat
}

// TODO: Remove these functions and their usages

export function openNeviseCreator() {
  WappPanel.openWapp({ wappId: NEVISEH_CREATOR_WAPP_ID })
}

export function openUsageDashboard(adminMode?: boolean, userId?: string) {
  WappPanel.openWapp({
    wappId: USAGE_DASHBOARD_WAPP_ID,
    input: { adminMode, userId },
  })
}

export function openBlogCreator() {
  WappPanel.openWapp({ wappId: BLOG_CREATOR_WAPP_ID })
}

export function openForumCreator() {
  WappPanel.openWapp({ wappId: FORUM_CREATOR_WAPP_ID })
}

export function openRahkarCreator() {
  WappPanel.openWapp({ wappId: RAHKAR_CREATOR_WAPP_ID })
}

export function openEventCreator() {
  WappPanel.openWapp({ wappId: EVENT_CREATOR_WAPP_ID })
}

export function openMultimediaCreator(type?: MultimediaType) {
  WappPanel.openWapp({
    wappId: MULTIMEDIA_CREATOR_WAPP_ID,
    ...(type && { input: { type } }),
  })
}
export function openMap() {
  OverlayWappPanel.openWapp({
    wappId: MAP_WAPP_ID,
  })
}
export function openSupportWapp() {
  WappPanel.openWapp({
    wappId: SUPPORT_WAPP_ID,
  })
}

export function openStudentSupportWapp() {
  WappPanel.openWapp({
    wappId: STUDENT_SUPPORT_WAPP_ID,
  })
}

export const MULTIMEDIA_TYPES = {
  'ویدیو کلیپ': 'videoClip',
  'فیلم و مستند': 'movie',
  'صوت و موسیقی': 'music',
  پادکست: 'podcast',
  'طرح گرافیکی': 'picture',
  کتاب: 'book',
  'نرم افزار': 'application',
  غیره: 'file',
} as const

export type MultimediaLabelType = keyof typeof MULTIMEDIA_TYPES
export type MultimediaType = (typeof MULTIMEDIA_TYPES)[MultimediaLabelType]
